<zimmerer-route-ion-wrapper class="ion-page">
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col noSlider" fxLayout="column" fxLayoutGap="20px">
      <div class="register-header">Registriere dein Konto</div>
      <div>Bitte schließe deine Registrierung ab und gib hier deinen Namen ein.</div>
      <form *ngIf="form" [formGroup]="form" fxLayout="column" fxLayoutGap="20px" fxFlex="30">
        <input matInput type="text" placeholder="Vorname" formControlName="firstname" />

        <input matInput type="text" placeholder="Nachname" formControlName="lastname" />

        <agb-newsletter [darklinks]="true" [(form)]="form"></agb-newsletter>

        <div class="form-group" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <button [disabled]="loading" class="btn btn-warn" (click)="onCancel()">Abbrechen</button>
          <button [disabled]="loading || form.invalid" (click)="onSubmit()" class="btn btn-success">
            Registrieren
          </button>
        </div>
      </form>
    </div>
  </div>
</zimmerer-route-ion-wrapper>
